import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.form = this.element.querySelector('form');
    this.incluirImporteSwitch = this.form.querySelector('#incluirImporteSwitch');
    this.importeInput = this.form.querySelector('#autorizacion_importe');
    this.botonLimpiarDestinatarios = this.form.querySelector('#boton-limpia-destinatarios');
    this.selectDestinatarios = this.form.querySelector('.destinatarios-autorizaciones .select-cifra');

    this._onIncluirImporteSwitch = () => this.onIncluirImporteSwitch();
    this._onClickLimpiar = () => this.limpiarDestinatarios();

    if (this.incluirImporteSwitch) {
      this.incluirImporteSwitch.addEventListener('change', this._onIncluirImporteSwitch);
    }
    if (this.botonLimpiarDestinatarios && this.selectDestinatarios) {
      this.botonLimpiarDestinatarios.addEventListener('click', this._onClickLimpiar);
    }
  }

  disconnect() {
    if (this.incluirImporteSwitch) {
      this.incluirImporteSwitch.removeEventListener('change', this._onIncluirImporteSwitch);
    }
    if (this.botonLimpiarDestinatarios) {
      this.botonLimpiarDestinatarios.removeEventListener('click', this._onClickLimpiar);
    }
  }

  onIncluirImporteSwitch() {
    if (this.incluirImporteSwitch.checked) {
      this.importeInput.disabled = '';
    } else {
      this.importeInput.disabled = 'disabled';
    }
  }

  limpiarDestinatarios() {
    this.selectDestinatarios?.dispatchEvent(new CustomEvent('select-cifra:limpiar'));
  }
}
